export default {
  liveDataSummary: 'Anfragen ändern Live-Daten',
  liveDataDetails: 'Jede Anfrage, die Sie hier senden, wirkt mit Ihren Berechtigungen auf Live-Daten. Änderungen und Löschungen gelten sofort und lassen sich nicht rückgängig machen.',
};
